'use client';

import { useState } from 'react';
import Image from 'next/image';
import { Typography } from '@bgzt/ui';

import { ReviewItem } from '~/apis/review/get-shop-reviews';

import styles from './ShopReviewThumbnail.module.css';

type Props = {
  images?: ReviewItem['images'];
  onClick?: () => void;
};
export const ShopReviewThumbnail = ({ images, onClick }: Props) => {
  const [error, isError] = useState(false);

  if (!images || error) return null;
  return (
    <div className={styles.container} onClick={onClick}>
      {images?.length > 1 && (
        <div className={styles.imageCountPlaceholder}>
          <Typography variant="L14" color="white">
            +{images?.length - 1}
          </Typography>
        </div>
      )}

      <Image
        className={styles.image}
        src={images[0].thumbnail.small as string}
        width={32}
        height={32}
        unoptimized
        alt={`후기 이미지`}
        onError={() => {
          isError(true);
        }}
      />
    </div>
  );
};
